import murmur from '../../engine/engine/murmur3/murmur3';
import { buildKey } from './';
export function hashImpression32(impression) {
  return impression ? murmur.hash(buildKey(impression)).toString() : null;
}


// WEBPACK FOOTER //
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@splitsoftware/splitio-react/es/splitio/impressions/hasher/hashImpression32.js